import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Animations } from '@motes-sdk/animations';
import { Media } from '@motes-sdk/models/media';

@Component({
    selector: 'simple-modal',
    templateUrl: './simple-modal.component.html',
    styleUrls: ['./simple-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [Animations.fadeInOut(200, 100)]
})
export class SimpleModalComponent implements OnInit, OnDestroy {

    @HostListener('window:resize', ['$event']) onResize() {
        this.isMobileWidth = (typeof window != 'undefined') && (window.innerWidth <= 600);
    }

    @Input() title: string = '';
    @Input() description: string = '';
    @Input() image: Media = null;
    @Input() okLabel: string = $localize`Ok`;
    @Input() cancelLabel: string = $localize`Cancel`;
    @Input() disableOk: boolean = false;
    @Input() disableCancel: boolean = false;
    @Input() hideOk: boolean = false;
    @Input() hideCancel: boolean = false;
    @Input() disableOutsideClick: boolean = false;
    @Input() redOk: boolean = false;
    @Input() disableCloseOnOk: boolean = false;
    /** Set modal style */
    @Input() bgColor: 'light-bg' | 'dark-bg' = 'light-bg';
    /** To close modal automatically, input time (in ms) between show and hide */
    @Input() automaticHidingTime: number;
    @Input('show') set setShow(show: boolean) {
        if(show) this.showModal();
        else this.hideModal();
    }

    @Output() showChange = new EventEmitter<boolean>();
    @Output() onOk = new EventEmitter<void>();
    @Output() onCancel = new EventEmitter<void>();

    public isModalVisible: boolean = false;
    public isMobileWidth: boolean = false;
    private hidingTimeout = null;

    ngOnInit() {
        this.isMobileWidth = (typeof window != 'undefined') && (window.innerWidth <= 600);
    }

    public okClicked() {
        if(!this.disableCloseOnOk) this.hideModal();
        this.onOk.emit();
    }

    public cancelClicked() {
        this.hideModal();
        this.onCancel.emit();
    }

    public hideModal() {
        this.isModalVisible = false;
        // Enable body scroll again
        document.body.classList.remove('modal-open');
        // Stop hiding-timeout if applicable
        if(this.hidingTimeout) clearTimeout(this.hidingTimeout);
        // Notify hide
        this.showChange.emit(this.isModalVisible);
    }

    private showModal() {
        this.isModalVisible = true;
        // Prevent body from scrolling while modal is shown
        document.body.classList.add('modal-open');
        // Add automatic hiding if applicable
        if(this.automaticHidingTime > 0) {
            this.hidingTimeout = setTimeout(() => { this.hideModal(); }, this.automaticHidingTime);
        }
    }

    ngOnDestroy(): void {
        this.hideModal();
    }
}
